import { keyDomainFor, type SearchKeyDomain } from '@shared/core/search';

import type { EntitledSearchCredentials } from '../providers/SearchKeyProvider';
import { createAlgoliaTransport } from './algolia';
import type { SearchTransport } from './types';
import { createTypesenseTransport } from './typesense';

export { SearchAuthError, type SearchTransport, type TransportRequest } from './types';

export const domainKey = (credentials: EntitledSearchCredentials, domain: SearchKeyDomain): string | undefined =>
  domain === 'orders' ? credentials.keys.orders : (credentials.keys.general ?? undefined);

export function createSearchTransport(
  credentials: EntitledSearchCredentials,
  collection: string
): SearchTransport | null {
  const key = domainKey(credentials, keyDomainFor(collection));
  if (key === undefined) return null;
  return credentials.engine === 'typesense'
    ? createTypesenseTransport(credentials.endpoint, key)
    : createAlgoliaTransport(credentials.endpoint, key);
}
